
import { Component, Prop, Vue } from 'bits/vue'

@Component({})
export default class OzLoadingSpinner extends Vue {
  @Prop({ type: Number, default: 48 }) readonly size!: number
  @Prop({ type: String, default: 'rainbow' }) readonly color!: 'rainbow' | 'black' | 'white' | 'yellow'
  @Prop({ default: 'default' }) variation!: 'default' | 'dashed'
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  get style() {
    if (!this.size) return undefined
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
    }
  }

  get strokeWidth(): number {
    if (!this.size) return 2
    if (this.size < 30) {
      return 4
    }
    return 2
  }
}
